export var riskType = {
    'budget': '预算',
    'dataLinkLedger': '台账',
    'costControl': '费用标准',
    'expense': '易购',
    'submit': '提交次数',
    'remunerationInfo': '酬金申报',
    'invoice': '发票',
    'loan': '借款',
    'loanRemain': '借款',
    'requisitionInfo': '报销金额',
    'invoiceReview': '发票复核',
    'trip': '行程',
    'dataLinkFilter': '业务对象',
    'flowQuery': '单据联查'
};
export var RiskTypeEnum;
(function (RiskTypeEnum) {
    RiskTypeEnum["Budget"] = "budget";
    RiskTypeEnum["CostControl"] = "costControl";
    RiskTypeEnum["DataLinkLedger"] = "dataLinkLedger";
    RiskTypeEnum["Invoice"] = "invoice";
})(RiskTypeEnum || (RiskTypeEnum = {}));
